import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Popup } from 'semantic-ui-react';
import { ReactComponent as SvgMenuList1 } from 'images/menu_list-academic_building.svg';
import { ReactComponent as SvgMenuList2 } from 'images/menu_list-printing_service.svg';
import { ReactComponent as SvgMenuList3 } from 'images/menu_list-administrative_office.svg';
import { ReactComponent as SvgMenuList4 } from 'images/menu_list-parking.svg';
import { ReactComponent as SvgMenuList5 } from 'images/menu_list-residential_college.svg';
import { ReactComponent as SvgMenuList6 } from 'images/menu_list-bus_stop.svg';
import { ReactComponent as SvgMenuList7 } from 'images/menu_list-staff_living_quarter.svg';
import { ReactComponent as SvgMenuList8 } from 'images/menu_list-restaurant.svg';
import { ReactComponent as SvgMenuList9 } from 'images/menu_list-sports_venue.svg';
import { ReactComponent as SvgMenuList10 } from 'images/menu_list-outlet.svg';
import { ReactComponent as SvgMenuList11 } from 'images/menu_list-outdoor_wifi_ap.svg';
import { ReactComponent as SvgMenuList12 } from 'images/menu_list-other_facilities.svg';

import { clearWaypoints, clearRoutes } from 'actions/directionsActions';

import { 
  generateLocationsName, 
  generateLocationsDescription, 
  mapGetGeoJsonIDsbyFilter, 
  mapFlyToGeoJsonObject_byID, 
  mapMakerGeoJsonObject_byIDs, 
  defaultMarkerIcon, 
  mapClearAllLayerContents,
} from 'utils/mapUtils';
import { 
  menuList_Academic, 
  menuList_Administrative,
  menuList_Printing,
  menuList_Parking,
  menuList_ResidentialCollege,
  menuList_BusStop,
  menuList_LivingQuater,
  menuList_Restaurant,
  menuList_Outlet,
  menuList_OtherFacilities,
  menuList_SportFacilities,
} from 'utils/mapMenu';

const generateMenuMap = (geoJsonIDs, activeLang, geoJsonId) => {
  const createMenuItem = (id) => ({
    id,
    title: generateLocationsName(id, activeLang),
    description: generateLocationsDescription(id, activeLang),
    onClick: (dispatch, map) => {
      //console.log("OnClick, geoJsonId(before changed):", geoJsonId);
      geoJsonId = id; 
      //console.log("OnClick, geoJsonId(after changed):", geoJsonId);
      mapFlyToGeoJsonObject_byID(map, id, activeLang, defaultMarkerIcon);
      
    }
  });

  const menuMap = {};
  for (const category in geoJsonIDs) {
    menuMap[category] = geoJsonIDs[category].ids.map(createMenuItem);
  }
  return menuMap;
};



const LocationsPicker = ({ dispatch, locations, map, activeLang, showDirectionsPanel, onCloseSidebar}) => {

  const umLocationsGeoJsonIDs = {
    menuList1: { 
      ids: menuList_Academic,
      icon: <SvgMenuList1 />,
      description: activeLang === 'zh' ? "學術大樓" : "Academic Building"
    },
    menuList2: { 
      ids: menuList_Printing,
      icon: <SvgMenuList2 />,      
      description: activeLang === 'zh' ? "打印服務" : "Printing Service"
    },  
    menuList3: { 
      ids: menuList_Administrative,
      icon: <SvgMenuList3 />,      
      description: activeLang === 'zh' ? "行政辦公室" : "Administrative Office"
    },
    menuList4: { 
      ids: menuList_Parking,
      icon: <SvgMenuList4 />,      
      description: activeLang === 'zh' ? "停車場" : "Parking"
    },
    menuList5: { 
      ids: menuList_ResidentialCollege,
      icon: <SvgMenuList5 />,      
      description: activeLang === 'zh' ? "住宿式書院" : "Residential College"
    },  
    menuList6: { 
      ids: menuList_BusStop,
      icon: <SvgMenuList6 />,      
      description: activeLang === 'zh' ? "巴士站" : "Bus Stop"
    },
    menuList7: { 
      ids: menuList_LivingQuater,
      icon: <SvgMenuList7 />,      
      description: activeLang === 'zh' ? "宿舍" : "Living Quater"
    },    
    menuList8: { 
      ids: menuList_Restaurant,
      icon: <SvgMenuList8 />,      
      description: activeLang === 'zh' ? "餐廳" : "Restaurant"
    },          
    menuList9: { 
      //ids: mapGetGeoJsonIDsbyFilter("amenity","sport"),    
      ids: menuList_SportFacilities,
      icon: <SvgMenuList9 />,      
      description: activeLang === 'zh' ? "運動場地" : "Sport Venue"
    },  
    menuList10: { 
      ids: menuList_Outlet,
      icon: <SvgMenuList10 />,      
      description: activeLang === 'zh' ? "商舖" : "Outlet"
    },  
    menuList11: { 
      ids: mapGetGeoJsonIDsbyFilter("internet_access:ssid","UM_PUBLIC_WIFI"),    
      icon: <SvgMenuList11 />,      
      description: activeLang === 'zh' ? "室外 Wi-Fi AP" : "Outdoor Wi-Fi AP"
    },  
    menuList12: { 
      ids: menuList_OtherFacilities,
      icon: <SvgMenuList12 />,      
      description: activeLang === 'zh' ? "其他設施" : "Other Facilities"
    },      
  };  

  const [visibleList, setVisibleList] = useState(null);
  const menuMap = generateMenuMap(umLocationsGeoJsonIDs, activeLang);

  const handleButtonClick = (location) => {
    setVisibleList(location);
    const locationIDs = menuMap[location].map(item => item.id).filter(id => id); // 過濾掉空字符串
    if (map) {
      mapClearAllLayerContents(map);      
      dispatch(clearWaypoints());
      dispatch(clearRoutes());      
    }       
    mapMakerGeoJsonObject_byIDs(map, locationIDs, [22.1300296, 113.5444218], activeLang);
  };

  return (
    <div>
      <div style={{ padding: '10px', backgroundColor: '#ffffff', display: 'grid', gridTemplateRows: 'repeat(2, auto)', gridAutoFlow: 'column', gap: '5px', justifyContent: 'flex-start' }}>
        {locations.map((location, i) => (
          <Popup
            key={i}
            content={umLocationsGeoJsonIDs[location].description} 
            size='small'
            trigger={
              <Button 
                onClick={() => handleButtonClick(location)} 
                style={{ padding: '.5em', height: '40px', backgroundColor: 'white', border: '1px solid #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <div style={{ width: '24px', height: '24px' }}>
                  {umLocationsGeoJsonIDs[location].icon}
                </div>
              </Button>
            }
          />
        ))}
      </div>
      
      <div style={{ padding: '10px', overflowY: 'auto', maxHeight: 'calc(100vh - 60px)' }}>
        {visibleList && (
          <div>
            {menuMap[visibleList].map((item, index) => (
              <div key={index} style={{ marginBottom: '20px', width: '300px' }}>
                <a 
                  href="#" 
                  onClick={() => {
                    item.onClick(dispatch, map, activeLang);
                    onCloseSidebar();
                  }} 
                  style={{ display: 'block', fontWeight: 'bold', textDecoration: 'none', color: 'blue', wordWrap: 'break-word' }}
                >
                  {item.title}
                </a>
                <p style={{ wordWrap: 'break-word', color: 'blue' }}>{item.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

LocationsPicker.propTypes = {
  dispatch: PropTypes.func.isRequired,
  locations: PropTypes.array.isRequired,
  map: PropTypes.object,
  activeLang: PropTypes.string.isRequired, 
  geoJsonId: PropTypes.string,
  srcCoord: PropTypes.string,
  showDirectionsPanel: PropTypes.bool.isRequired, 
  onCloseSidebar: PropTypes.func.isRequired, 
};

export default connect()(LocationsPicker);